//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { BookOutlined, FileSearchOutlined, LinkOutlined, MenuFoldOutlined, MenuUnfoldOutlined, MergeCellsOutlined , SettingOutlined, CloseOutlined, ProfileOutlined, CloudServerOutlined, ClusterOutlined, ContainerOutlined, GoogleOutlined, RocketOutlined, PlayCircleOutlined, FileSyncOutlined, PictureOutlined, BulbOutlined, WarningOutlined, HistoryOutlined, CloseCircleOutlined, HighlightOutlined, SearchOutlined, UserSwitchOutlined , MessageOutlined, BugOutlined, SecurityScanOutlined, BarChartOutlined} from '@ant-design/icons';
import { FormatQuoteOutlined, Home, Audiotrack, YouTube } from '@mui/icons-material';
//  -- Components ---------------------
import { Button, Drawer, Dropdown, Layout, Menu, Space  , Select, message } from 'antd';
import LogoIcon from 'components/LogoIcon';

//  -- Features -----------------------
import { get , map , orderBy  , find , sortBy , filter } from 'lodash';
import React, { useState , useEffect, useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
//  -- Thunks -------------------------
import { handleLogout } from 'store/auth/thunks';
import { useCurrentUser, useProfilePicturePicker, useUserProfileConfig } from "store/users/selectors";
import styled from 'styled-components';
//  -- Constants ----------------------
import { handleInvokeFeedbackForm } from 'store/feedback/thunks';
import { useCurrentOrg, useDistricts } from "store/organizations/selectors";
import { profileArrow, userImg } from "utils/assets/images";
import COLOR from 'utils/constants/color';
import { MenuItem } from '@mui/material'
import { handleGetOrganization } from 'store/organizations/thunks';
import { getAvatar } from 'utils/assets/images/lootie';
import {CastForEducationSharp} from '@mui/icons-material';
import { checkWorksheetUser } from 'utils/config/reference';
import { useHasPermission, useHasAnyPermission } from 'utils/permissions';


import WordBank from 'modules/word_bank/admin/inapporiate_word';
import { updateVocabCognates } from 'store/widgetWheel/actions';
import { handleAutologinOneGame, handleSyncBookCategories } from 'store/one_game/thunks';
import SpinLoader from 'components/Loader/SpinLoader';
import ViewUserInfoModal from 'components/ViewUserInfoModal';
import config from 'config';
const { Header, Sider, Content } = Layout;

function getItem(label, key, icon, children, type) {
    return {
        key,
        icon,
        children,
        label,
        type,
    };
}

const worksheetItem = [
    getItem('Grammar Drills', 'worksheet', <FileSearchOutlined style={{ fontSize: '20px' }} />),
]

const itemss = [
    getItem('Home', 'Home', <Home style={{ fontSize: '20px' }} />),
    getItem('Data Browser', 'dataBrowser', <FileSearchOutlined style={{ fontSize: '20px' }} />),
    getItem('Global Search', 'globalSearch', <SearchOutlined style={{ fontSize: '20px' }} />),
    getItem('Standard', 'standard_menu', <ProfileOutlined style={{ fontSize: '20px' }} />, [
        getItem('Standards', 'standard', <ProfileOutlined style={{ fontSize: '20px' }} />),
        getItem('Standards dashboard', 'standards_dashboard', <BarChartOutlined style={{ fontSize: '20px' }} />),
    ]),
    getItem('Quotes', 'quotes', <FormatQuoteOutlined style={{ fontSize: '20px' }} />),
    getItem('Teacher support', 'teacher_support', <MessageOutlined style={{ fontSize: '20px' }} />),
    getItem('User Reported Issues', 'feedback_reports', <BugOutlined style={{ fontSize: '20px' }} />),
    getItem('Grammar Drills', 'worksheet', <FileSearchOutlined style={{ fontSize: '20px' }} />),
    getItem('Integrations', 'ebook', <MergeCellsOutlined style={{ fontSize: '20px' }} />, [
        getItem('Schoology', 'Schoology', <CloudServerOutlined style={{ fontSize: '20px' }} />),
        getItem('Classlink', 'Classlink', <LinkOutlined style={{ fontSize: '20px' }} />),
        getItem('Clever', 'Clever', <ClusterOutlined style={{ fontSize: '20px' }} />),
        getItem('Canvas', 'Canvas', <ContainerOutlined style={{ fontSize: '20px' }} />),
        getItem('Google', 'Google', <GoogleOutlined style={{ fontSize: '20px' }} />)
    ]
    ),
    getItem('Edit Books', 'editBooks', <BookOutlined style={{ fontSize: '20px' }} />),
    getItem('1Game', 'oneGame', <RocketOutlined style={{ fontSize: '20px' }} />, [
        getItem('Tutorials', 'Tutorials', <PlayCircleOutlined style={{ fontSize: '20px' }} />),
        getItem('Update', 'Update', <FileSyncOutlined style={{ fontSize: '20px' }} />),
        getItem('Video', 'Video', <YouTube style={{ fontSize: '20px' }} />),
        getItem('Gallery', 'Gallery', <PictureOutlined style={{ fontSize: '20px' }} />),
        getItem('Login As Admin', 'login_as_admin', <UserSwitchOutlined style={{ fontSize: '20px' }} />),
    ]
    ),
    getItem('Placement exam', 'placement_exam', <CastForEducationSharp style={{ fontSize: '20px' }} />),
    getItem('Inappropriate', 'inappropriate', <WarningOutlined style={{ fontSize: '20px' }} />, [
        getItem('Vocab cognates', 'vocab_cogantes', <HighlightOutlined style={{ fontSize: '20px' }} />),
        getItem('Words', 'inappropriate_words', <CloseCircleOutlined style={{ fontSize: '20px' }} />),
        getItem('Logs', 'inappropriate_words_logs', <HistoryOutlined style={{ fontSize: '20px' }} />),

    ]),
    getItem('What\'s New', 'whatsNew', <BulbOutlined style={{ fontSize: '20px' }}/>),
    getItem('Image gallery', 'image_gallery', <PictureOutlined style={{ fontSize: '20px' }}/>),
    getItem('Audio', 'audio_gallery', <Audiotrack style={{ fontSize: '20px' }} />),
    getItem('Super Admin Control Panel', 'superAdminControlPanel', <SecurityScanOutlined style={{ fontSize: '20px' }} />),
    getItem('Settings', 'settings', <SettingOutlined style={{ fontSize: '20px' }} />),
];

const SideNavSection = styled.div`
`;
const LogoContainer = styled.div`
  margin-top:20px;
  display:flex;
  align-items:center;
  justify-content:center;
  cursor:pointer;
`;

const OverviewText = styled.span`
  color: white;
  font-size: 19px;
  font-weight: 600;
  display:flex !important;
  align-items:center;
`;
const RowContainer = styled.div`
    border-left: ${p => p.border && `1px solid ${COLOR.black700}`};
    margin-left: 10px;
    padding-left: 20px;
`;

const UserContainer = styled.div`
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-direction: row;
`;
const UserDetails = styled.div`
    ${'' /* display: none; */}
    flex-direction: column;
    justify-content: flex-end;
    margin-right: 8px;

    @media (min-width: 768px) {
        display: flex;
    }
`;
const UserDetailsMob = styled.div`
    display: none;
    flex-direction: column;
    justify-content: flex-end;
    margin-right: 8px;

    @media (max-width: 768px) {
        display: flex;
    }
`;

const MobileBar = styled.div`
    /* border-bottom: 1px solid ${COLOR.black800}; */
    display: block;
    height: 60px;
    padding: 8px 16px;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;

    @media (min-width: 992px) {
        display: none;
    }
    @media (min-width: 772px) {
       background-color:black;
    }
    @media (max-width: 568px) {
        padding: 8px 10px;
    }
`;

const UserName = styled.span`
    color: white;
    display: none;
    font-size: 11px;
    font-weight: 600;
    line-height: 14px;
    margin-bottom: 0px;
    @media (min-width: 768px) {
        display: block;
    }
`;
const Wrappers = styled.div`
  height: 100%;
  width: 100%;
`;

const configServer = import.meta.env.VITE_APP_STAGE?.trim() === 'prod'
    ? 'prod'
    : 'dev';

export default function District_admin({ children }) {
    const districts = useDistricts()
    const [placement, setPlacement] = useState('left');
    const [opens, setOpens] = useState(false);
    const currentUser = useCurrentUser()
    const currentOrg  = useCurrentOrg()
    const [collapsed, setCollapsed] = useState(false);
    const dispatch = useDispatch();
  	const navigate = useNavigate();
    const [editName, setEditName] = useState(false)
    const [gameRedirectLoader, setGameRedirectLoader] = useState(false);
    const [filteredDistricts, setFilteredDistricts] = useState([]);
    const viewInfoModalRef = useRef(null);
    const { profile_config } = useUserProfileConfig()
    const { showProfilePhotoViewer } = useProfilePicturePicker();

    const hasDataBrowser = useHasPermission('data_browser.access');
    const hasGlobalSearch = useHasPermission('global_search.access');
    const hasStandard = useHasAnyPermission(['standard.view', 'standard.add', 'standard.edit', 'standard.delete']);
    const hasQuotes = useHasAnyPermission(['quotes.view', 'quotes.add', 'quotes.edit', 'quotes.delete']);
    const hasTeacherSupport = useHasPermission('teacher_support.access');
    const hasUserReportedIssue = useHasPermission('user_reported_issue.access');
    const hasGrammarDrill = useHasAnyPermission(['grammar_drill.view', 'grammar_drill.add', 'grammar_drill.edit', 'grammar_drill.delete', 'grammar_drill.approve']);
    const hasIntegrationSearch = useHasPermission('integration_search.access');
    const hasEditBooks = useHasAnyPermission(['edit_books.view', 'edit_books.add', 'edit_books.edit', 'edit_books.activate']);
    const hasGameTutorial = useHasPermission('game.tutorial');
    const hasGameUpdates = useHasPermission('game.updates');
    const hasGameGallery = useHasPermission('game.gallery');
    const hasGameLoginAsAdmin = useHasPermission('game.login_as_admin');
    const hasPlacementExam = useHasAnyPermission(['placement_exam.view', 'placement_exam.add', 'placement_exam.edit', 'placement_exam.duplicate', 'placement_exam.delete', 'placement_exam.assignment_management', 'placement_exam.rubrics_management']);
    const hasInappropriate = useHasPermission('inappropriate.access');
    const hasWhatsNew = useHasPermission('whats_new.access');
    const hasImageGallery = useHasPermission('image_gallery.access');
    const hasAudioGallery = useHasPermission('audio_gallery.access');
    const hasSuperAdminManagement = useHasPermission('super_admin_management.access');
    const hasSettings = useHasAnyPermission(['settings.welcome_video', 'settings.fun_video_teacher', 'settings.fun_video_student', 'settings.demo_video']);

    const getItems = useMemo(() => {
        if (checkWorksheetUser(currentUser?.id)) {
            return worksheetItem
        } else {
            return itemss;
        }
    }, [currentUser])
    
    useEffect(() => {
        setFilterdDistrict(districts)
    }, [districts])

    const setFilterdDistrict = (dist) => {
        if (dist) {
            try {
                const cOrg = find(dist, d => d?.id == get(currentOrg, "id"))
            if (cOrg) {
                const sortedDist = sortBy(filter(dist, d => d.id != get(currentOrg, "id")), ["displayName"])
                const res = [cOrg, ...sortedDist]
                setFilteredDistricts(res)
            } else {
                setFilteredDistricts(sortBy(dist, ["displayName"]))
            }
 
            } catch (error) {
                
            }
           
        } else {
            setFilteredDistricts([])
        }
    }
    const onClose = () => {
        setOpens(false);
    };
    const showDrawer = () => {
        setOpens(true);
    };
    const getRoute = () => {
        if (checkWorksheetUser(currentUser?.id)) {
            navigate('/worksheet');
            return;
        };
        navigate('/dashboard');
    };
    const onLogOutPress = () => {
        dispatch(handleLogout());
        navigate('/');
    }
    const navigatePath = (path) => {
        navigate(path);
        setOpens(false)
    };

    const onRedirect1Game = async () => {
      setGameRedirectLoader(true);
      const data = await dispatch(
        handleAutologinOneGame(currentUser.id, '', {
          user_role_admin: currentUser?.role === 'owe_admin',
          action: "home_game",
          role: "teacher",
          class_info: {},
          user_type: "owe",
          // grade_category,
          // grade_type
        })
      );
      dispatch(handleSyncBookCategories(currentUser.id));
      if (data && data.key) {
        let uri = `https://1gamestaging.nosotrosonline.com/session_auth`;
        if (config.is_local) {
          uri = `http://${window.location.hostname}:3011/session_auth`;
        } else if (configServer === 'prod') {
            uri = 'https://1game.nosotrosonline.com/session_auth';
        }
        const url = `${uri}?key=${data.key}`;
        // openOnegameModal(url);
        const newWindow = window.open(url, '_blank', 'toolbar=0,location=0,menubar=0');
        
        if (newWindow) {
            newWindow.opener = null;
        } else {
            alert("Pop-up blocked. Please allow pop-ups for this site.");
        }
      }
      setGameRedirectLoader(false)
      // handleCancel()
    };

    const checkPermission = (key) => {
        if (key === 'dataBrowser') return hasDataBrowser;
        if (key === 'globalSearch') return hasGlobalSearch;
        if (key === 'standard_menu' || key === 'standard' || key === 'standards_dashboard') return hasStandard;
        if (key === 'quotes') return hasQuotes;
        if (key === 'teacher_support') return hasTeacherSupport;
        if (key === 'feedback_reports') return hasUserReportedIssue;
        if (key === 'worksheet') return hasGrammarDrill;
        if (key === 'ebook') return hasIntegrationSearch;
        if (key === 'Schoology' || key === 'Classlink' || key === 'Clever' || key === 'Canvas' || key === 'Google') return hasIntegrationSearch;
        if (key === 'editBooks') return hasEditBooks;
        if (key === 'Tutorials') return hasGameTutorial;
        if (key === 'Update') return hasGameUpdates;
        if (key === 'Video') return hasGameTutorial;
        if (key === 'Gallery') return hasGameGallery;
        if (key === 'login_as_admin') return hasGameLoginAsAdmin;
        if (key === 'placement_exam') return hasPlacementExam;
        if (key === 'vocab_cogantes' || key === 'inappropriate_words' || key === 'inappropriate_words_logs') return hasInappropriate;
        if (key === 'whatsNew') return hasWhatsNew;
        if (key === 'image_gallery') return hasImageGallery;
        if (key === 'audio_gallery') return hasAudioGallery;
        if (key === 'superAdminControlPanel') return hasSuperAdminManagement;
        if (key === 'settings') return hasSettings;
        if (key === 'Home') return true;
        return true;
    };

    const handleClick = async ({ key }) => {
        if (!checkPermission(key)) {
            message.warning('You do not have permission to access this feature.');
            return;
        }

        const routes = {
            "Home": "/dashboard",
            "globalSearch": "/global-admin-search",
            "dataBrowser": "/data-browsers",
            logs: "/logs",
            "Schoology": "/schoology",
            "Classlink": "/classlink",
            "Clever": "/clever",
            "Canvas": "/canvas",
            "Google": "/google",
            "editBooks": "/editBooks",
            "settings": "/settings",
            "standard": "/standard",
            "standards_dashboard": "/standards-dashboard",
            "worksheet": "/worksheet",
            "Tutorials": "/edit-1game-tutorial",
            "Update": "/edit-1game-update",
            "Video": "/edit-1game-video",
            "Gallery": "/edit-1game-gallery",
            "login_as_admin": "/login_as_admin",
            'placement_exam':"/placement_exam",
            'vocab_cogantes': "/vocab_cogantes",
            'inappropriate_words':"/inappropriate_words",
            'inappropriate_words_logs':"/inappropriate_words_logs",
            "whatsNew":"/whatsNew",
            "image_gallery":"/image_gallery",
            "audio_gallery":"/audio_gallery",
            "quotes": "/quotes",
            "teacher_support": "/teacher_support",
            "feedback_reports": "/feedback_reports",
            "superAdminControlPanel": "/super-admin-control-panel"
        };
        const path = routes[key];
        if(path === "/vocab_cogantes"){
            await dispatch(updateVocabCognates({ open: true }))
            return;
        }
        if (path === "/login_as_admin") {
            onRedirect1Game();
            return;
        }
        if (path) navigatePath(path);
    };
    const invokeFeedback = () => {
        dispatch(handleInvokeFeedbackForm())
    }
    const handleCurrentOrgLoader = async (data) => {
        if (currentOrg?.id !== data) {
            localStorage.setItem("lastActiveOrgAdmin", data)
            await dispatch(handleGetOrganization(data))
        }
    }
    const userNav = () => ({
        items: [
            {
                key: 'change-avatar',
                label: (
                    <Button className='menuBtnItem' type="text" onClick={showProfilePhotoViewer}>
                        Change Avatar
                    </Button>
                )
            },
            {
                key: 'reset-password',
                label: (
                    <Button className='menuBtnItem' type="text" onClick={() => navigatePath('/account')}>
                        Reset Password
                    </Button>
                )
            },
            {
                key: 'view-info',
                label: (
                    <Button className='menuBtnItem' type="text" onClick={() => viewInfoModalRef.current?.open()}>
                        User info
                    </Button>
                )
            },
            {
                key: 'report-issue',
                label: (
                    <Button className='menuBtnItem' type="text" onClick={invokeFeedback}>
                        Report an issue
                    </Button>
                )
            },
            {
                key: 'logout',
                label: (
                    <Button className='menuBtnItem' type="text" onClick={onLogOutPress}>
                        Logout
                    </Button>
                )
            }
        ]
    });
    const getUserProfileImg = useMemo(() => {
        if (profile_config && profile_config.config) {
            const avt = getAvatar(profile_config.config.profile_pic)
            if (avt) {
                return avt
            }
        }
        return userImg;
    }, [profile_config])
    return (
        <Wrappers>
            <WordBank from={{from: "admin", page: "inapporiate-word"}} />
            <SpinLoader dataloader={gameRedirectLoader} />
        <Layout>
            <Drawer
                title={get(currentOrg, 'displayName', '')}
                placement={placement}
                closable={false}
                onClose={onClose}
                open={opens}
                key={placement}
                width="378"
                className="ownDrawer setAdminDrawer"
                extra={
                    <Space>

                        <CloseOutlined onClick={onClose} style={{ color: 'white', fontSize: 20 }} />
                    </Space>
                }
            >
                <SideNavSection >
                    <LogoContainer onClick={getRoute}>
                        {!collapsed ? <LogoIcon height={100} /> : <LogoIcon height={60} />}
                    </LogoContainer>
                        <Menu
                            className="bgImages"
                            style={{ marginTop: '20px' }}
                            onClick={handleClick}
                            theme="dark"
                            mode="inline"
                            defaultSelectedKeys={['Home']}
                            items={getItems}
                        />
                </SideNavSection>
            </Drawer>
            <Sider trigger={null} collapsible collapsed={collapsed} className="hides">
                <LogoContainer onClick={getRoute}>
                    {!collapsed ? <LogoIcon height={100} /> : <LogoIcon height={60} />}
                </LogoContainer>
                <Menu
                    className="bgImages"
                    style={{ marginTop: '20px' }}
                    onClick={handleClick}
                    theme="dark"
                    mode="inline"
                    defaultSelectedKeys={['Home']}
                    items={getItems}
                />
            </Sider>
            <Layout>
                <Header
                    className="cstmHeaderOld setBGSection"
                >
                    <div style={{ display: 'flex', alignItems: 'center' }} className="headDropdown 1212">
                    {!checkWorksheetUser(currentUser?.id) && (
                        <>
                        {!editName ? (
                            <div style={{ alignItems: 'center' }} className="manageBtn" onClick={() => setEditName(!editName)}>
                                <Button
                                    type="text"
                                    className="hides"
                                    onClick={() => setCollapsed(!collapsed)}
                                    style={{
                                        fontSize: '19px',
                                        width: 50,
                                        height: 64,
                                        color: 'white'
                                    }}
                                >
                                    {collapsed ? <MenuUnfoldOutlined style={{ marginRight: '5px', marginTop: 5 }} /> : <MenuFoldOutlined style={{ marginRight: '5px', marginTop: 5 }} />}
                                </Button>
                                <OverviewText>
                                    {get(currentOrg, 'displayName', '')}
                                </OverviewText>
                            </div>
                        ) : (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Button
                                    type="text"
                                    className="hides"
                                    onClick={() => setCollapsed(!collapsed)}
                                    style={{
                                        fontSize: '19px',
                                        //width: 50,
                                        minHeight: 64,
                                        color: 'white'
                                    }}
                                >
                                    {collapsed ? <MenuUnfoldOutlined style={{ marginRight: '5px', marginTop: 5 }} /> : <MenuFoldOutlined style={{ marginRight: '5px', marginTop: 5 }} />}
                                </Button>
                                <Select
                                    onBlur={() => setEditName(false)}
                                    defaultValue={get(currentOrg, 'displayName', '')}
                                    showSearch
                                    style={{
                                        width: 200,
                                    }}
                                    filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                    filterSort={(optionA, optionB) =>
                                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                    }
                                    bordered={false}
                                    className='mainLabel hides'
                                    onChange={(e) => {
                                        handleCurrentOrgLoader(e)
                                        setEditName(false)
                                    }}
                                >
                                    {map(orderBy(filteredDistricts, "asc"), st => (<MenuItem key={st?.id} value={st.id} label={st.displayName}
                                    >{st.displayName}</MenuItem>))}
                                </Select>
                            </div>

                        )}
                        <Button
                            type="text"
                            className="unhides"
                            onClick={() => showDrawer()}
                            style={{
                                fontSize: '16px',
                                // width: 64,
                                height: 64,
                                color: 'white'
                            }}
                        >
                            <OverviewText>{collapsed ? <MenuUnfoldOutlined style={{ marginRight: '5px' }} /> : <MenuFoldOutlined style={{ marginRight: '5px' }} />} {get(currentOrg, 'displayName', '')}</OverviewText>
                        </Button>
                        </>
                    )}
                    </div>

                    <RowContainer className="usrDetailUpr" border={currentUser?.role === 'teacher' || currentUser?.role === 'admin'}>
                        <Dropdown className="usrDetailInr" menu={userNav()} placement="bottomRight" trigger={['click']}>
                            <UserContainer>
                                <UserDetails className="usrDetail">
                                    <div className="usrDetailInfo allUsrDetailInfo" style={{ borderTop: 'none', borderBottom: 'none' }}>
                                        <div className="usrPic"><img src={getUserProfileImg} /></div>
                                        <div><UserName>{currentUser?.firstName} {currentUser?.lastName}</UserName></div>
                                        <div className="usrArrow"><img src={profileArrow} /></div>
                                    </div>
                                </UserDetails>
                                {/* <UserDetailsMob className="usrDetail">
                                    <div className="usrPic"><img src={getUserProfileImg} /></div>
                                </UserDetailsMob> */}
                            </UserContainer>
                        </Dropdown>
                    </RowContainer>
                </Header>
                <Content
                    style={{
                        // margin: '24px 16px',
                        padding: 24,
                        minHeight: '86vh',
                        background: 'white',
                    }}
                >
                    {children}
                </Content>
            </Layout>
        </Layout>
        <ViewUserInfoModal ref={viewInfoModalRef} />
    </Wrappers>
    )
}
